import {
    baseStates,
    baseMutations,
    baseActions,
    baseGetters,
} from '@/stores/base';

export const companyVehicleReading = {

    namespaced: true,

    state:
    {
        ...baseStates,

        url: '/vehicle/readings',
    },

    mutations:
    {
        ...baseMutations,
    },

    actions:
    {
        ...baseActions,
    },

    getters:
    {
        ...baseGetters,

        vehicleTypes: state => state.vehicleTypes,
    },
};
